export default {
  "affordable.package.offer": "Edullinen pakettitarjous",
  "customize.package": "Räätälöi oma pakettisi",
  "amount": "Määrä",
  "customizable.box.reservations": "Jos et halua valmista pakettia, voit räätälöidä itse laatikoiden määrän ja varauksen keston.",
  "number.of.moving.boxes": "Muuttolaatikoiden määrä",
  "reserve": "Varaa",
  "select.rental.end.date": "Valitse päättymispäivä",
  "total.amount": "Kokonaismäärä",
  "make.a.payment": "Suorita Maksu",
  "pickup": "Nouto",
  "box.pickup.or.delivery": "Valitse, haetko muuttolaatikot itse vai toimitetaanko ne sinulle.",
  "delivery.service": "Toimituspalvelu",
  "transport.fee": "kuljetusmaksu",
  "pick.up.myself": "Noudan itse",
  "rental.start.date": "Vuokrauksen alkamispäivä",
  "start.time": "Alkamisaika",
  "open.mon.fri": "Avoinna Ma-Pe",
  "clock": "klo",
  "july": "heinäkuussa",
  "delivery.address.specification": "Katuosoite ja talon numero mihin muuttolaatikoit toimitetaan",
  "entrence.door.number": "Rappu ja ovinumero",
  "more.information": "Lisätietoa",
  "esim": "Esim",
  "door.code": "ovikoodi",
  "backwards": "Taaksenpäin",
  "forward": "Eteenpäin",
  "personal.information": "Henkilötiedot",
  "first.name": "Etunimi",
  "last.name": "Sukunimi",
  "telephone.number": "Puhelinnumero",
  "return": "Palautus",
  "self.return.or.pickup": "Valitse, palautatko itse tai noudetaanko muuttolaatikot sinulta.",
  "rental.end.date": "Vuokrauksen päättymispäivä",
  "pickup.address.specification":  "Katuosoite ja talon numero mistä muuttolaatikot noudamme",
  "successfully": "Menestys",
  "payment.received.confirmation": "Saimme maksusi",
  "thank.you.message": "Kiitos, että valitsit meidät",
  "go.to.home.page": "Mene kotisivulle",
  "order.confirmation.reminder": "Tilaus on lähetetty sähköpostitse HUOMIOI ROSKAPOSTI. Vahvista tilauksesi 2 tunnin sisällä. Tilaus raukeaa 2 tunnin jälkeen jos sita ei ole vahvistettu",
  "thank.you": "Kuitos",
  "moving.box.size": "Muuttolaatikko koko",
  "delivery": "Toimitus",
  "delivery.address.provided": "Katuosoite mihin muuttolaatikoit toimitetaan",
  "pickup.address.provided": "Katuosoite mistä muuttolaatikot noudamme",
  "moving.boxes.rental": "Muuttolaatikot vuokraus",
  "delivery.of.moving.boxes": "Muuttolatikoiden tooimitus",
  "collection.of.moving.boxes": "Muuttolaatikoiden nouto",
  "amount.to.be.paid": "Maksettava summa",
  "discount.price": "Alennushinta"
};
